/** Hand-drawn silhouettes are shared by the HUD, shop, and controls legend. */
const paths: Record<string, string> = {
  fireball:
    '<path d="M17 5c-1 7 8 4 8 12a10 10 0 1 1-18-6c-1 7 5 8 5 2 0-3 2-6 5-8Z"/><path d="m3 4 8 4M1 11l6 2M7 1l6 5"/>',
  dash: '<path d="m15 4 13 12-13 12 3-9H4l5-6h9Z"/><path d="M3 5h8M1 26h9"/>',
  teleport:
    '<ellipse cx="10" cy="17" rx="6" ry="12"/><ellipse cx="25" cy="17" rx="3" ry="9"/><path d="M8 17h17m-4-4 4 4-4 4M7 3l3-2 3 2"/>',
  shield:
    '<path d="M16 2 28 7v9c0 7-12 14-12 14S4 23 4 16V7Z"/><path d="m16 7 6 9-6 9-6-9Z"/>',
  deflector:
    '<path d="M23 3a14 14 0 0 0 0 26M21 6a11 11 0 0 0 0 20M30 11H13l6-6M13 11l6 6M13 21h17l-5-5M30 21l-5 5"/>',
  meteor:
    '<path d="m27 2-9 6m12-3-5 10M19 3 9 12"/><path d="M19 11a9 9 0 1 1-13 1l7-4 1 6Z"/><path d="M4 29h24"/>',
  dome: '<path d="M2 25a14 14 0 0 1 28 0Z"/><path d="M16 11c-8 8-7 14 0 14s8-6 0-14ZM2 25c6 5 22 5 28 0M16 3v3M4 7l3 3m21-3-3 3"/>',
  lightning_strike: '<path d="m19 1-3 12h10L10 31l4-14H5Z"/>',
  settings:
    '<path d="m12 2-1 5-4 2-4-1-2 6 4 3v4l-2 4 5 4 4-3 4 1 2 4 6-2v-5l3-3 5-1v-6l-5-2-2-3V5l-6-3-3 4Z"/><circle cx="16" cy="16" r="5"/>',
  crown: '<path d="m3 8 7 6 6-10 6 10 7-6-3 18H6Z"/><path d="M7 30h18"/>',
  eye: '<path d="M1 16S7 6 16 6s15 10 15 10-6 10-15 10S1 16 1 16Z"/><circle cx="16" cy="16" r="5"/>',
  coin: '<circle cx="16" cy="16" r="13"/><path d="m16 7 3 6 6 3-6 3-3 6-3-6-6-3 6-3Z"/>',
  link: '<path d="m12 20 8-8M11 23l-3 3a6 6 0 0 1-8-8l7-7a6 6 0 0 1 8 0m2-2 3-3a6 6 0 0 1 8 8l-7 7a6 6 0 0 1-8 0"/>',
  chevron: '<path d="m12 7 9 9-9 9"/>',
  close: '<path d="m8 8 16 16M24 8 8 24"/>',
  plus: '<path d="M16 5v22M5 16h22"/>',
  edit: '<path d="m6 21 15-15 5 5-15 15-7 2ZM18 9l5 5"/>',
  person:
    '<circle cx="16" cy="9" r="6"/><path d="M5 29v-5a11 11 0 0 1 22 0v5Z"/>',
  check: '<path d="m5 17 7 7L28 7"/>',
  sound:
    '<path d="M3 12h6l8-7v22l-8-7H3ZM22 10c5 3 5 9 0 12m4-16c8 5 8 15 0 20"/>',
};
export function icon(name: string, cls = ""): string {
  return `<svg class="icon ${cls}" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths[name] ?? paths.fireball}</svg>`;
}
